<div class="erroInfo" fxLayoutAlign="space-arround center">
  <mat-icon class="errorIcon">error</mat-icon>
  &nbsp;&nbsp;&nbsp;
  <span [innerHTML]="message"></span>
</div>
